import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

export const SET_UNREAD_COUNT = 'INTERCOM/SET_UNREAD_COUNT';
export const SET_DELIVERY_PREF_ORDER_ID = 'ORDERS/SET_DELIVERY_PREF_ORDER_ID';



const defaultSelection={
  tPrefRadio: 'Royal Mail delivery rm',
   torderid :"",
}
const flow='orders'
export const setUnreadCount = (count) => ({
  type: SET_UNREAD_COUNT,
  count,
});


export const setDeliveryPrefOrderId = () => ({
  type: SET_DELIVERY_PREF_ORDER_ID,
  payload: {
    tPrefRadio: defaultSelection.tPrefRadio, 
    torderid: defaultSelection.torderid,
  },
  flow,
});

export const getUnreadCount = state => state.count;

const count = handleActions({
  [SET_UNREAD_COUNT]: (state, action) => action.count,
}, 0);



export const deliveryPreference = handleActions(
  {
    [SET_DELIVERY_PREF_ORDER_ID]: (state, action) => {
      return action.payload;
    },
  },
  defaultSelection
);

export default combineReducers({ count ,deliveryPreference});
